<template>
  <el-dialog :visible="true" @close="$emit('close')">
    <div class="text-center">
      <div>
        <span>请用微信扫描二维码关注公众号</span>
      </div>
      <img :src="qrcode" alt="" width="200" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DygcQrCode',
  data() {
    return {
      qrcode: require('@/assets/img/qrcode/dygc-pro.jpeg')
    }
  }
}
</script>
